import { FC } from "react";

import { isFuture, isWithinInterval } from "date-fns";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import Counter from "components/Counter";
import { COUNTER_SIZES } from "components/Counter/sizes";

import { Client } from "services/store/Store.interface";

import styles from "./styles";

interface NewStoreDetailsProps {
  details: Pick<
    Client,
    "name" | "description" | "startSellingDate" | "endDate" | "isCreatedByForm"
  >;
  socialsComponent?: JSX.Element | JSX.Element[];
}

const NewStoreDetails: FC<NewStoreDetailsProps> = ({
  details,
  socialsComponent,
}) => {
  return (
    <Box sx={styles.container}>
      {socialsComponent}
      {details?.description && (
        <Typography
          justifyContent="center"
          display="flex"
          maxWidth="1000px"
          mx="auto"
          align="center"
          variant="h4"
          component="h4"
          fontWeight={400}
          sx={{
            mt: 2,
            mb: 2,
            lineHeight: "1.4em",
            whiteSpace: "pre-line",
          }}
          {...(details.isCreatedByForm
            ? {
                children: details?.description,
              }
            : {
                dangerouslySetInnerHTML: {
                  __html: `<div>${details?.description}</div>`,
                },
              })}
        />
      )}
      {details?.startSellingDate &&
        isFuture(new Date(details.startSellingDate)) && (
          <Box
            display="flex"
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent="center"
            sx={{ display: { xs: "flex" } }}
            mb={2}
          >
            <Typography
              justifyContent="center"
              display="flex"
              maxWidth="1000px"
              mx="auto"
              align="center"
              variant="h4"
              component="h4"
              fontWeight={400}
              mb={2}
            >
              {details.name} starts in:
            </Typography>
            <Counter
              size={COUNTER_SIZES.LARGE}
              time={details.startSellingDate}
            />
          </Box>
        )}
      {details?.endDate &&
        details?.startSellingDate &&
        isWithinInterval(new Date(), {
          start: new Date(details.startSellingDate),
          end: new Date(details.endDate),
        }) && (
          <Box
            display="flex"
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent="center"
            sx={{ display: { xs: "flex" } }}
            mb={2}
          >
            <Typography
              justifyContent="center"
              display="flex"
              maxWidth="1000px"
              mx="auto"
              align="center"
              variant="h4"
              component="h4"
              fontWeight={400}
              mb={2}
            >
              {details?.name} ends in
            </Typography>
            <Counter size={COUNTER_SIZES.LARGE} time={details.endDate} />
          </Box>
        )}
    </Box>
  );
};

export default NewStoreDetails;
